﻿/*-------------------------------------------------------
'   @module: ART - Navigation
'---------------------------------------------------------*/

export class TechnoNavigation{
    constructor() {
        this.technoNavigationSelector = `[data-op-navtype="art-simple"]`;
        this.technoNavigation = document.querySelectorAll(this.technoNavigationSelector);
        this.toggleSubmenuSelector = `[data-art-navigation="toggle-submenu"]`;

        if(this.technoNavigation.length > 0) {
            this.attachEventListener();
        }
    }

    attachEventListener() {
        this.technoNavigation.forEach(navigation => {
            navigation.addEventListener('click', e => {
                if(e.target.closest(this.toggleSubmenuSelector)) {
                    e.stopPropagation();
                    e.preventDefault();

                    const menu = e.target.closest('.has-children');

                    if(menu) {
                        menu.classList.toggle('is-open');
                    }
                }
            });
        });
    }
}


new TechnoNavigation();